import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v16h16l4 4z"
}), 'ModeCommentSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ModeCommentSharp.js
// module id = 4874
// module chunks = 2